import { SafeUrl } from '@angular/platform-browser';
import { DocumentType } from 'src/app/models/enums/document-type';
import { CommentInput } from 'src/app/models/server/comment-input';
import { TchatRoom } from 'src/app/models/server/tchat-room';
import { ViewerDisplayMode } from './viewer-display-mode';

export class ViewerContext {
    /**
     * Dans le cas d'un fichier JSON contenant une conversation Tchat, représentation de la conversation Tchat.
     */
    public room: TchatRoom = null;

    /**
     * Dans le cas d'un document de type commentaire, Liste des commentaires.
     */
    public comments: CommentInput[] = null;

    /**
     * Dans le cas d'un document de type commentaire, indique le type de commentaire.
     */
    public commentType: DocumentType = null;

    /**
     * Url vers la représentation mémoire du fichier sélectionné.
     */
    public safeFileUrl: SafeUrl = null;

    /**
     * Contenu d'un fichier de type texte.
     */
    public textFileContent: string = null;

    /**
     * Valeur indiquant si le fichier selectionné doit être affiché dans la prévisualisation.
     */
    public displayPreview: Boolean = true;

    /**
     * Valeur indiquant si le fichier selectionné est une image.
     */
    public isImageFile: Boolean = false;

    constructor(public displayMode: ViewerDisplayMode) {
        this.room = null;
        this.comments = null;
        this.commentType = null;
        this.safeFileUrl = null;
        this.textFileContent = null;
        this.isImageFile = false;

        if (displayMode === ViewerDisplayMode.None) {
            this.displayPreview = false;
        } else {
            this.displayPreview = true;
        }
    }
}
